import * as React from "react";
function SvgPivotTable(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M31 7H1M7 7v24"
      />
      <rect
        x={1}
        y={1}
        width={30}
        height={30}
        rx={1}
        ry={1}
        fill="none"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle cx={13} cy={13} r={1.5} />
      <circle cx={19} cy={13} r={1.5} />
      <circle cx={25} cy={13} r={2} />
      <circle cx={13} cy={25} r={1} />
      <circle cx={19} cy={25} r={1.5} />
      <circle cx={25} cy={25} r={1} />
      <circle cx={13} cy={19} r={2} />
      <circle cx={19} cy={19} r={1.5} />
      <circle cx={25} cy={19} r={1.5} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPivotTable);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
